import { trpc } from '@/shared/api/trpc';

export const useOrganizationsList = (enabled = true) =>
  trpc.organizations.list.useQuery(undefined, { enabled });
